<script lang="ts">
  import FullScreenModal from '@/components/shared/FullScreenModal.svelte'
  import { onMount } from 'svelte'
  import groupsStore from '@/stores/groups.svelte'
  import { fade } from 'svelte/transition'
  import globalStore from '@/stores/global.svelte'

  let {
    show = false,
    value = $bindable([]),
    onClose = () => {},
  } = $props()

  let showWas = $state(false)
  let showNewForm = $state(false)
  let newGroupName = $state('')
  let selectedGroups = $state([])
  let selectedGroupIds = $state([])

  let groupsByName = $derived(groupsStore.groupsByName)

  let newGroupInput = $state(null)

  $effect(() => {
    // console.log('in effect', { show, showWas })
    if (show && !showWas) {
      // console.log('doing the effect')
      showWas = true
      selectedGroups = value || []
      selectedGroupIds = selectedGroups.map(group => group.id)
    }
  })

  onMount(() => {
    groupsStore.fetch()
  })

  function createNewClicked() {
    groupsStore.createNewGroup(newGroupName)
      .then(group => {
        groupsStore.fetch()
          .then(_ => {
            // Fake a click
            groupsChanged({ target: { checked: true } }, group)
          })

        showNewForm = false
        newGroupName = null
      })
  }

  // The way we've implemented value on this is a bit convoluted:
  // The shape of Group from a keyword vs from groupsByName is different,
  // so we can't just bind value to the groups from the keyword.
  // The current solution is to bind to just the IDs, the downside is
  // that we have to manually maintain selectedGroups and selectedGroupIds
  function groupsChanged(evt, group) {
    // let newId = group.id
    // let newGroupIds = [...selectedGroupIds]
    //
    // if (evt.target.checked) {
    //   newGroupIds.push(newId)
    // } else {
    //   newGroupIds = reject(newGroupIds, id => id === newId)
    // }
    //
    // newGroupIds = uniq(newGroupIds)
    // selectedGroups = groupsByName.filter(group => newGroupIds.indexOf(group.id) > -1)
    // console.log('groupsChanged', { selectedGroupIds })
    selectedGroups = groupsByName.filter(group => selectedGroupIds.indexOf(group.id) > -1)
    // console.log('selectedGroups is now', { selectedGroups })
  }

  function save() {
    value = selectedGroups
    close()
  }

  function toggleNewForm() {
    showNewForm = !showNewForm

    if (showNewForm) {
      window.setTimeout(_ => newGroupInput.focus(), 100)
    }
  }

  function close() {
    showWas = false
    onClose()
  }

  // $inspect({
  //   selectedGroups,
  //   selectedGroupIds
  // })
</script>

<FullScreenModal title="Add to a Group" {show} onClose={close}>
  <div class="AddToGroupForm">

    <div class="add-groups__container panel--green">
      <div class="row">
        <div class="col-sm-6">
          <div class="add-groups__title">
            <i class="icon icon--group"></i>
            Choose Your Groups
          </div>
        </div>
        <div class="col-sm-6 text-right">
          <button type="button" class="btn btn-link btn-green" onclick={toggleNewForm}>Add New Group</button>
        </div>
      </div>

      {#if showNewForm}
        <div class="add-groups__new" transition:fade>
          <div class="row">
            <div class="col-sm-8">
              <div class="form-group">
                <label for="new-group-name">Group Name</label>
                <input
                  type="text"
                  class="form-control"
                  bind:value={newGroupName}
                  bind:this={newGroupInput}
                  required={showNewForm}
                  placeholder="Group Name"
                  onkeyup={(evt) => evt.key === 'Enter' && createNewClicked}
                />

                <div class="form-errors" class:d-none={!globalStore.errors.length}>
                  <div class="form-errors__inner active">
                    <div class="form-errors__title">Please fix this:</div>
                    <div class="form-errors__msg">{globalStore.errors}</div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-sm-4">
              <label for="new-group-name">&nbsp;</label>
              <button type="button" class="btn btn-green btn-rounded" onclick={createNewClicked}>Create New</button>
            </div>
          </div>
        </div>
      {/if}

      <h4 class="text-center mt-3 m-b-3" class:d-none={groupsByName.length}>
        You don't have any groups yet. Add a new one above!
      </h4>

      <div class="add-groups__list">
        {#each groupsByName as group (group.id)}
          <div class="add-groups__list-item">
            <input type="checkbox"
                   class="square"
                   id="item-{group.id}"
                   value={group.id}
                   bind:group={selectedGroupIds}
                   onchange={(evt) => groupsChanged(evt, group)}
            />
            <label for="item-{group.id}">{group.name}</label>
          </div>
        {/each}
      </div>
    </div>

    <div class="mt-2 text-center">
      <button type="button" class="btn btn-white btn-rounded" onclick={save}>Save</button>
    </div>
  </div>
</FullScreenModal>
